module.exports = __webpack_public_path__ + "img/icone_vazamento_interno_vermelho.937fe7c4.png";